module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/cloud-infor-phone2.5cced60d.png";